import { Pages, Roles } from '../../context/contexts/UserContext/permissionsTypes';
import useHasPermissions from '../../hooks/useHasPermissions';
import { LogicalRoute, LogicalRouteImportProps } from '../helpers/LogicalRoute';
import SystemNotifications from '../../components/Notifications/SystemNotifications';

export const SystemNotificationsRouting = (props: LogicalRouteImportProps) => {
    const disabled = !useHasPermissions({ permission: Pages.NOTIFICATIONS, role: Roles.VIEWER });

    return <LogicalRoute {...props} component={SystemNotifications} disabled={disabled} />;
};
